// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiveLinkController from "./active_link_controller"
application.register("active-link", ActiveLinkController)

import AutoExpandingTextAreaController from "./auto_expanding_text_area_controller"
application.register("auto-expanding-text-area", AutoExpandingTextAreaController)

import BookmarksImportController from "./bookmarks_import_controller"
application.register("bookmarks-import", BookmarksImportController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import ExclusiveCheckboxesController from "./exclusive_checkboxes_controller"
application.register("exclusive-checkboxes", ExclusiveCheckboxesController)

import FormController from "./form_controller"
application.register("form", FormController)

import HotkeyController from "./hotkey_controller"
application.register("hotkey", HotkeyController)

import InlineFormController from "./inline_form_controller"
application.register("inline-form", InlineFormController)

import KeyboardInsetController from "./keyboard_inset_controller"
application.register("keyboard-inset", KeyboardInsetController)

import MasonryController from "./masonry_controller"
application.register("masonry", MasonryController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NoteFormController from "./note_form_controller"
application.register("note-form", NoteFormController)

import NoteStatsController from "./note_stats_controller"
application.register("note-stats", NoteStatsController)

import NuggitsViewController from "./nuggits_view_controller"
application.register("nuggits-view", NuggitsViewController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ReaderController from "./reader_controller"
application.register("reader", ReaderController)

import SearchDialogController from "./search_dialog_controller"
application.register("search-dialog", SearchDialogController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SidebarToggleController from "./sidebar_toggle_controller"
application.register("sidebar-toggle", SidebarToggleController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import StreamRendererController from "./stream_renderer_controller"
application.register("stream-renderer", StreamRendererController)

import SyntaxHighlightController from "./syntax_highlight_controller"
application.register("syntax-highlight", SyntaxHighlightController)

import TitleTooltipController from "./title_tooltip_controller"
application.register("title-tooltip", TitleTooltipController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TreeController__TreeController from "./tree_controller/tree_controller"
application.register("tree--tree", TreeController__TreeController)

import WebShareController from "./web_share_controller"
application.register("web-share", WebShareController)
